// FOR HANDLING REQUEST
import moment from 'moment'
import Numeral from 'numeral'
import { getCartItemTotal, getProductCategories, getProductCategoriesNames } from './defaultSelectors'
import { convertToBoolean, excludeFromRetail, isCoreProduct, getSOH, locationsWithIds, getCoreRange } from '../_utils'
import { getProductURL } from './productSelectors'
import { getPaymentGateway, getCardId } from './defaultSelectors'
import { InvoiceStatusColor, PurchaseStatusColor } from '../3pl/data/threePlCreditAccountData'
import { getProductsImage } from '../selectors/productSelectors'
import { WeekViewOrderStatusList } from '../3pl/data/orderStatusWeekViewData'

export const getProductImage = (item) => {
  const { ListImg, PType } = item

  if (ListImg) {
    return ListImg
  } else if (window.defaultImagePlaceHolder !== '') {
    return window.defaultImagePlaceHolder
  }

  switch (PType) {
    case 'Beer Kegs':
      return '/assets/bulkUpload/5e6a64c073/GENERIC-KEG2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Beer Package':
      return '/assets/bulkUpload/63505f40da/GENERIC-BEER-STUB2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Cider Kegs':
      return '/assets/bulkUpload/5e6a64c073/GENERIC-KEG2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Cider Package':
      return '/assets/bulkUpload/80065fc083/GENERIC-CAN2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Flavoured Cider Package':
      return '/assets/bulkUpload/80065fc083/GENERIC-CAN2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Non Alc (Ex CDS)':
      return '/assets/bulkUpload/5f32f76abb/GENERIC-NON-ALC2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Non Alc No GST (Ex CDS)':
      return '/assets/bulkUpload/5f32f76abb/GENERIC-NON-ALC2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Non Alcoholic':
      return '/assets/bulkUpload/5f32f76abb/GENERIC-NON-ALC2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Non Alcoholic (No GST)':
      return '/assets/bulkUpload/5f32f76abb/GENERIC-NON-ALC2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'

    case 'Premix':
      return '/assets/bulkUpload/561364fcb6/GENERIC-SPIRIT2000x2000px-v2__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Premix Kegs':
      return '/assets/bulkUpload/5e6a64c073/GENERIC-KEG2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Spirits':
      return '/assets/bulkUpload/561364fcb6/GENERIC-SPIRIT2000x2000px-v2__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'

    case 'Wine Kegs':
      return '/assets/bulkUpload/5e6a64c073/GENERIC-KEG2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Wine Package':
      return '/assets/bulkUpload/e5b958b42b/GENERIC-WINE-BTL2000x2000px__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    case 'Sundry':
      return '/assets/bulkUpload/6766ac3d2f/image-2020-01-24-09-50-49-500__PadWzMwMCwyMDAsIkZGRkZGRiIsMTAwXQ.png'
    // case '': return '';
  }

  return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAADICAYAAABS39xVAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4wcDATofVfIJyQAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAD9SURBVHja7cEBAQAAAICQ/q/uCAoAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGKp1AAEU6coPAAAAAElFTkSuQmCC'
  // return 'https://placehold.it/240x240';
}
/**
 * Get Products Full Info (for Supplier & 3PL)
 * @param list
 * @param store
 */

export const getAdvancedShippingNoticeItems = (ansDetail = [], list = []) => {
  if (list.length == 0) {
    return list
  }
  let newList = list || []
  for (let i = 0; i < newList?.length; i++) {
    let foundProduct = ansDetail.find((item) => item.ProductID == newList[i].id)
    if (foundProduct && Object.keys(foundProduct).length > 0) {
      newList[i].Weight = foundProduct.Weight || 0
      newList[i].Carton = foundProduct.Carton || 0
      newList[i].CartonReceived = foundProduct.CartonReceived || 0
    } else {
      newList[i].Weight = 0
      newList[i].Carton = 0
      newList[i].CartonReceived = 0
    }
  }
  return newList
}

export const getProductsFullInfo = (list, store) => {
  const activeCustomer = store.supplier.activeCustomer
  const activeCustomerID = typeof activeCustomer != 'undefined' && activeCustomer ? activeCustomer.id : 0
  const user = store.user
  const paramaountCustomer = localStorage.getItem('paramountCustomer')
  let selectedLocation = ''
  if (window.is3PLSupplier && window.currentWarehouseID && paramaountCustomer == 'false') {
    let found = locationsWithIds.find((item) => item.id == window.currentWarehouseID)
    selectedLocation = found.location
    // console.log("warehouseCode =========== getProductsFullInfo 11111111" , {found , currentWarehouseID: window.currentWarehouseID})
  }

  const warehouseCode = selectedLocation || user?.warehouseCode
  // console.log("warehouseCode =========== getProductsFullInfo" , window.is3PLSupplier && window.currentWarehouseID && !paramaountCustomer, {is3PLSupplier: window.is3PLSupplier , currentWarehouseID: window.currentWarehouseID,paramaountCustomer}, {selectedLocation , user, warehouseCode, warehouseCodeUser: user?.warehouseCode})
  const cartList = getDumbCartForMember(store.cartSupplier.list, activeCustomerID)
  // const categoriesList = store.categories.list;
  const userInput = store.productsSupplier.userInput

  let newList = {}

  Object.entries(list).map(([key, product]) => {
    if (list[key].sohRaw !== undefined) {
      const isCore = isCoreProduct(warehouseCode, list[key].soldAt)
      const isCoreRange = getCoreRange(user?.enLocationID, list[key].isCoreRange)

      newList[key] = {
        ...list[key],
        isCore,
        soh: getSOH(isCore, warehouseCode, list[key].sohRaw, isCoreRange, list[key].translationRedemptionID),
        //soh: warehouseMapping(warehouseCode, list[key].sohRaw),
      }

      newList[key].calculatedSOH = newList[key].soh
    }
  })

  newList = updateAvailableQty({ ...newList }, cartList)

  Object.entries(newList).map(([key, product]) => {
    const { id } = product
    const inputItem = userInput[id]

    if (inputItem) {
      const {
        calculatedSOH,
        soh,
        qty_per_case,
        sell_by_case,
        caseQty,
        unitQty,
        caseBackOrder,
        unitBackOrder,
        cartQty,
        backOrderQty,
      } = newList[key]

      newList[key] = {
        ...newList[key],
        ...inputItem,
        calculatedSOH: calculatedSOH, // because inputItem keeps replacing :<
        // isCore: getIsCoreValue(list[key].soldAt, activeCustomer),
      }

      const sohDifference = cartQty - calculatedSOH

      if (sell_by_case) {
        if (cartQty >= calculatedSOH) {
          newList[key] = {
            ...newList[key],
            caseQty: calculatedSOH,
            caseBackOrder: caseBackOrder + sohDifference,
            cartQty: calculatedSOH,
            backOrderQty: backOrderQty + sohDifference,
          }
        }
      } else {
        if (cartQty >= calculatedSOH) {
          newList[key] = {
            ...newList[key],
            caseQty: caseQty + Math.floor(unitQty / qty_per_case),
            unitQty: calculatedSOH % qty_per_case,
            caseBackOrder: caseBackOrder + Math.floor(caseBackOrder / qty_per_case),
            unitBackOrder: (unitBackOrder + sohDifference) % qty_per_case,
            cartQty: calculatedSOH,
            backOrderQty: backOrderQty + sohDifference,
          }
        }
      }
    }
  })

  return newList
}

export const buildCheckoutData = (checkout) => {
  const checkoutDetails = checkout.details

  if (typeof checkoutDetails == 'undefined') {
    return {}
  }

  const { selectedCreditCard } = checkoutDetails
  let { selectedPaymentMethod } = checkoutDetails

  /*    const mapping = new Map([
        ['reference', 'reference'],
        ['notes', 'notes'],
        ['deliverydate', 'selectedDeliveryDate'],
        ['paymentmethod', 'selectedPaymentMethod'],
        ['creditcardid', 'selectedCreditCard'],
        ['address', 'selectedDeliveryAddressObj'],
    ]);*/

  let gateway = getPaymentGateway(selectedPaymentMethod)
  const selectedDate = moment(checkoutDetails.selectedDeliveryDate)
  const currentDate = moment(new Date())

  if (
    gateway == 'airwallex-card' &&
    parseInt(selectedDate.diff(currentDate, 'days')) < 29 &&
    checkout?.readGlobalConfig?.enableCCAuthorization
  ) {
    gateway = 'order-airwallex-card-authorization'
    selectedPaymentMethod = 'order-airwallex-card-authorization'
  }
  return {
    //will send by payForOrder api
    OrderID: checkout.cart.id,
    PaymentMethod: window?.is3PLSupplier ? 'order-account' : selectedPaymentMethod,
    CardID: getCardId(selectedPaymentMethod, selectedCreditCard),
    Gateway: gateway,
    PickupEmptyKegs: checkoutDetails.pickupEmptyKegs,
    KegsToPickUp: checkoutDetails?.kegsToPickup,
    //will send by updateCard api
    ShippingAddressID: checkoutDetails.selectedDeliveryAddress,
    Reference: checkoutDetails.reference,
    Notes: checkoutDetails.notes,
    DeliveryDate: checkoutDetails.selectedDeliveryDate,
  }
}

export const combineProductsWithCategories = (products, categories) => {
  let newList = { ...products }

  Object.entries(products).map(([key, product]) => {
    newList[key] = {
      ...newList[key],
      categories: getProductCategories(newList[key].categories, categories),
    }
    newList[key] = {
      ...newList[key],
      categoriesNames: getProductCategoriesNames(newList[key].categories),
    }
  })
  return newList
}
export const convertEdgesToReactSelectDynamic = (originalData) => {
  if (typeof originalData.edges == 'undefined') {
    return originalData
  }

  const data = originalData.edges.map((item) => {
    return {
      label: item.node.Title,
      value: item.node.ID,
    }
  })

  return data
}
export const convertEdgesToReactSelectStatic = (originalData) => {
  if (typeof originalData.edges == 'undefined') {
    return originalData
  }

  const data = originalData.edges.map((item) => {
    return parseInt(item.node.ID)
  })

  return data
}
export const convertCustomerGroupsToReactSelect = (originalData) => {
  const data = originalData.readElvantiProductPriceGroups.edges.map((item) => {
    return {
      label: item.node.Title,
      value: item.node.ID,
    }
  })

  return data
}
export const convertCustomerNamesToReactSelect = (originalData) => {
  const data = originalData.map((item) => {
    const { ID, Name } = item
    let { Is3PL } = item

    let option = {
      label: Name,
      value: ID,
      className: '',
    }

    if (typeof Is3PL != 'undefined') {
      if (typeof Is3PL == 'string') {
        Is3PL = Is3PL.toLowerCase() == 'true' ? true : false
      }

      option.className = Is3PL ? 'extra-tag extra-tag--3pl' : 'extra-tag extra-tag--supplier'
      option.is3PL = Is3PL
    }

    return option
  })

  return data
}
export const convertCustomerNameEdgesToReactSelect = (originalData) => {
  if (typeof originalData.edges == 'undefined') {
    return originalData
  }

  const data = originalData.edges.map((item) => {
    const { ID, FirstName, Surname, Email, EnCity, Company, InternalItemID } = item.node
    let name = ''

    // if (FirstName) {
    //   name += FirstName
    // }
    // if (Surname) {
    //   name += ' ' + Surname
    // }
    // if (Email) {
    //   name += ' (' + Email + ')'
    // }

    name = Company + `(#${InternalItemID}) `

    return {
      label: name.trim(),
      customerName: Company,
      value: ID,
      internalItemID: InternalItemID,
    }
  })

  return data
}
export const convertMemberNamesToReactSelect = (originalData) => {
  const data = originalData.map((item) => {
    const { ID, FirstName, Surname, Email, EnCity, Company, InternalItemID } = item
    let name = ''
    let value = ID
    // if (FirstName) {
    //   name += FirstName
    // }
    // if (Surname) {
    //   name += ' ' + Surname
    // }
    // if (Email) {
    //   name += ' (' + Email + ')'
    // }

    name = `(${InternalItemID}) ` + Company + ' - ' + EnCity

    return {
      label: name.trim(),
      value,
      original: item,
    }
  })

  return data
}

export const convertSupplerNamesToReactSelect = (originalData) => {
  const data = originalData.map((item) => {
    const { ID, FirstName, Surname, Email, EnCity, Company, InternalItemID } = item
    let name = ''
    let value = ID

    name = `(${ID || ''}) ${Company || ''} ${Email ? ' - ' + Email : ''}`

    return {
      label: name.trim(),
      value,
      original: item,
    }
  })

  return data
}

export const convertElasticProductsToReactSelect = (originalData) => {
  const data = originalData.map((item) => {
    return {
      label: item.title,
      value: parseInt(item.productID),
    }
  })

  data.sort((a, b) => (a.label > b.label ? 1 : -1))

  return data
}
export const convertDealBuilderListToReact = (edges, baseData) => {
  return edges.map((item) => convertDealBuilderSubmissionToReact(item.node, baseData))
}
export const convertDealBuilderSubmissionToReact = (rawItem, baseData = {}) => {
  let item = { ...rawItem }
  let convertedData = { ...item }

  if (typeof item.GetProducts != 'undefined' && typeof item.GetProducts.edges != 'undefined') {
    // For Details
    convertedData.GetProducts = item.GetProducts.edges.map((item) => item.node.ID)

    // For listing
    convertedData.GetProductsNode = item.GetProducts.edges.map((item) => item.node)
  }

  if (typeof item.BuyProducts != 'undefined' && typeof item.BuyProducts.edges != 'undefined') {
    // For Details
    convertedData.BuyProducts = item.BuyProducts.edges.map((item) => item.node.ID)

    // For listing
    convertedData.BuyProductsNode = item.BuyProducts.edges.map((item) => item.node)
  }

  // Convert promotion type
  // TODO: fix or remove
  // convertedData = convertPromotionTypeData(convertedData);

  // React Select conversion
  convertedData.Customers = convertCustomerNameEdgesToReactSelect(convertedData.Customers)
  // convertedData.buyProducts = convertEdgesToReactSelectStatic(convertedData.buyProducts);
  // convertedData.getProducts = convertEdgesToReactSelectStatic(convertedData.getProducts);

  convertedData.Zone = convertedData?.PromotionZone?.Title || ''

  if (convertedData.BuyProducts.length > 0) {
    convertedData.BuyProduct = convertedData.BuyProducts[0]
  }

  // Do some adjustment
  // TODO: do this?
  // convertedData.enabled = convertedData.durationTo === null ? 0 : 1;

  if (convertedData.FromDate === null) {
    convertedData.FromDate = moment().format('DD/MM/YYYY')
  } else {
    convertedData.FromDate = moment(convertedData.FromDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }

  if (convertedData.ToDate === null) {
    convertedData.ToDate = moment().add(1, 'month').format('DD/MM/YYYY')
  } else {
    convertedData.ToDate = moment(convertedData.ToDate, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }

  const data = {
    ...baseData,
    ...convertedData,
  }

  return data
}
export const convertPromotionListToReact = (edges, baseData) => {
  return edges.map((item) => convertPromotionDetailsToReact(item, baseData))
}
export const convertPromotionDetailsToReact = (rawItem, baseData) => {
  const mapping = new Map([
    ['id', 'ID'],
    ['title', 'Title'],
    ['durationFrom', 'FromDate'],
    ['durationTo', 'ToDate'],
    ['buyQuantity', 'BuyQty'],
    ['getQuantity', 'GetQty'],
    ['assignedCustomers', 'Customers'],
    // ['buyProducts', 'PromotionalProducts'],
  ])

  let convertedData = {
    discountType: 'Bonus',
    buyProducts: [],
    getProducts: [],
    buyProductsNode: [],
    getProductsNode: [],
  }

  let item = { ...rawItem }
  if (item.node !== undefined) {
    item = item.node
  }

  // Convert data based on the mapping
  mapping.forEach((requestKey, reactKey) => {
    if (typeof item[requestKey] != 'undefined') {
      convertedData[reactKey] = item[requestKey]
    }
  })

  if (typeof item.GetProducts != 'undefined' && typeof item.GetProducts.edges != 'undefined') {
    // For Details
    convertedData.getProducts = item.GetProducts.edges.map((item) => item.node.ID)

    // For listing
    convertedData.getProductsNode = item.GetProducts.edges.map((item) => item.node)
  }

  if (typeof item.BuyProducts != 'undefined' && typeof item.BuyProducts.edges != 'undefined') {
    // For Details
    convertedData.buyProducts = item.BuyProducts.edges.map((item) => item.node.ID)

    // For listing
    convertedData.buyProductsNode = item.BuyProducts.edges.map((item) => item.node)
  }

  // Convert promotion type
  // TODO: fix or remove
  // convertedData = convertPromotionTypeData(convertedData);

  // React Select conversion
  convertedData.assignedCustomers = convertCustomerNameEdgesToReactSelect(convertedData.assignedCustomers)
  // convertedData.buyProducts = convertEdgesToReactSelectStatic(convertedData.buyProducts);
  // convertedData.getProducts = convertEdgesToReactSelectStatic(convertedData.getProducts);

  if (convertedData.buyProducts.length > 0) {
    convertedData.buyProduct = convertedData.buyProducts[0]
  }

  // Do some adjustment
  // TODO: do this?
  // convertedData.enabled = convertedData.durationTo === null ? 0 : 1;

  if (convertedData.durationFrom === null) {
    convertedData.durationFrom = moment().format('DD/MM/YYYY')
  } else {
    convertedData.durationFrom = moment(convertedData.durationFrom, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }

  if (convertedData.durationTo === null) {
    convertedData.durationTo = moment().add(1, 'month').format('DD/MM/YYYY')
  } else {
    convertedData.durationTo = moment(convertedData.durationTo, 'YYYY-MM-DD').format('DD/MM/YYYY')
  }

  const data = {
    ...baseData,
    ...convertedData,
  }

  return data
}
export const convertBonusPromotionDetailsToReact = (originalData, baseData) => {
  const mapping = new Map([
    ['buyQuantity', 'BuyQuantity'],
    ['getQuantity', 'GetQuantity'],
  ])

  let convertedData = {}

  if (typeof originalData.readOneElvantiBonusPromotion != 'undefined') {
    const node = originalData.readOneElvantiBonusPromotion

    if (node != null) {
      // Convert data based on the mapping
      mapping.forEach((requestKey, reactKey) => {
        if (typeof node[requestKey] != 'undefined') {
          convertedData[reactKey] = node[requestKey]
        }
      })
    }
  }

  const data = {
    ...baseData,
    ...convertedData,
  }

  return data
}
export const convertPromotionTypeData = (convertedData) => {
  switch (convertedData.promotionType) {
    case 'BonusPromotion':
      convertedData.discountType = 'Bonus'
      convertedData.caseDiscountType = ''
      break

    case 'CaseFixedDiscountPromotion':
      convertedData.discountType = 'Case Discount'
      convertedData.caseDiscountType = 'Fixed Discount'
      break

    case 'CaseFixedPricePromotion':
      convertedData.discountType = 'Case Discount'
      convertedData.caseDiscountType = 'Fixed Price'
      break

    case 'CasePercentageDiscountPromotion':
      convertedData.discountType = 'Case Discount'
      convertedData.caseDiscountType = 'Percentage Discount'
      break
  }

  return convertedData
}
export const convertOrderReceiptToReact = (originalData) => {
  const mapping = new Map([
    ['title', 'Title'],
    ['productID', 'BuyableID'],
    ['qty_per_case', 'ConsumableUnitsPerCase'],
    ['sell_by_case', 'SellByCaseOnly'],
    ['sku', 'InternalItemID'],
    ['caseTotal', 'CaseQuantity'],
    ['case_price', 'CasePrice'],
    ['unitTotal', 'UnitQuantity'],
    ['unit_price', 'UnitPrice'],
    ['cartTotal', 'TotalPrice'],
  ])

  let list = []

  // First let's get all the data
  if (
    typeof originalData.readElvantiOrders != 'undefined' &&
    typeof originalData.readElvantiOrders.edges != 'undefined'
  ) {
    const edges = originalData.readElvantiOrders.edges

    edges.map((orderRaw, index) => {
      const orderNode = orderRaw.node

      const orderItems = orderNode.OrderItems.edges

      orderItems.map((orderItemRaw) => {
        const orderItemNode = orderItemRaw.node

        list.push(orderItemNode)
      })
    })
  }

  // Now do conversion
  list = list.map((item) => {
    let finalData = {}

    // Convert data based on the mapping
    mapping.forEach((requestKey, reactKey) => {
      if (typeof item[requestKey] != 'undefined') {
        finalData[reactKey] = item[requestKey]
      }
    })

    return finalData
  })

  return list
}
export const convertOrderReceiptDetailsToReact = (originalData) => {
  const mapping = new Map([
    ['id', 'ID'],
    ['shippingCost', 'ShippingTotal'],
    ['tax', 'TaxTotal'],
    ['subtotal', 'SubTotal'],
    ['total', 'Total'],
  ])

  let finalData = {}

  // First let's get all the data
  if (
    typeof originalData.readElvantiOrders != 'undefined' &&
    typeof originalData.readElvantiOrders.edges != 'undefined'
  ) {
    const edges = originalData.readElvantiOrders.edges

    edges.map((orderRaw) => {
      const orderNode = orderRaw.node

      // Convert data based on the mapping
      mapping.forEach((requestKey, reactKey) => {
        if (typeof orderNode[requestKey] != 'undefined') {
          finalData[reactKey] = orderNode[requestKey]
        }
      })
    })
  }

  return finalData
}
export const convertCartToReact = (cart, user) => {
  const list = cart.Items.edges.reduce((accumulator, item) => {
    const productID = item.node.Buyable.ID

    const {
      Brand,
      Varietal,
      LiquorStyle,
      BrandRegion,
      BrandCountry,
      ReSizedDefaultImage,
      ItemsInCase,
      ProductType,
      ContainerType,
      IsCoreRange = false,
    } = item.node.Buyable

    let image = getProductsImage(item.node.Buyable)

    /**
     *  Hide the cart item on checkout when the subtotal is 0
     */
    // if (Number(item.node.CalculatedSubTotalPrice) === 0) {
    //   return accumulator
    // }

    if (accumulator[productID] === undefined) {
      accumulator[productID] = {
        itemID: item.node.ID,
        isCore: null,
        isPromotion: null,
        title: item.node.Title,
        splitPackSize: item.node.Buyable.SplitPackSize,
        productID: item.node.Buyable.ID,
        qty_per_case: ItemsInCase,
        sell_by_case: 0,
        sku: item.node.Buyable.InternalItemID,
        url_slug: item.node.Buyable.URLSegment,
        caseTotal: 0,
        case_price: 0,
        unitTotal: 0,
        unit_price: 0,
        cartTotal: 0,
        wholesale_unit_per_case: item.node.Buyable.WholesaleUnitsPerCase,
        loyaltyPoints: Number(item.node.Buyable.LoyaltyPoints),
        supplierLoyaltyPoints: excludeFromRetail(item.node.Buyable.PointsExcludedFromRetail)
          ? 0
          : Number(item.node.Buyable.SupplierLoyaltyPoints),
        bonusLoyaltyPoints: excludeFromRetail(item.node.Buyable.PointsExcludedFromRetail)
          ? 0
          : Number(item.node.Buyable.BonusLoyaltyPoints),
        webCategory: item.node.Buyable.WebCategory,
        brand: Brand,
        varietal: Varietal,
        style: LiquorStyle,
        region: BrandRegion,
        country: BrandCountry,
        image,
        isCoreRange: getCoreRange(user?.enLocationID, IsCoreRange),
        miraklProduct: item.node.MiraklProduct,
        //pointsEarned: Number(item.node.PointsEarned),
        //statusCredits: Number(item.node.StatusCredits),
      }
    }

    accumulator[productID].cartTotal += Number(item.node.CalculatedSubTotalPrice)
    //accumulator[productID].rewardPoints += Number(item.node.PointsEarned);

    switch (item.node.BundleType) {
      case 'case':
        accumulator[productID].caseTotal += Number(item.node.TotalUnitItems)
        accumulator[productID].case_price += Number(item.node.UnitPrice)
        break
      case 'unit':
        accumulator[productID].unitTotal += Number(item.node.TotalUnitItems)
        accumulator[productID].unit_price += Number(item.node.UnitPrice)
        break
    }

    return accumulator
  }, {})

  return Object.values(list)
}

export const convertSupplierCartToReact = (cart, user) => {
  const list = cart.Items.edges.reduce((accumulator, item) => {
    const { Title, Buyable, SupplierPromotionDiscount, CalculatedSubTotalPrice, TotalUnitItems, UnitPrice } = item.node
    const {
      ID: BuyableID,
      InternalItemID,
      URLSegment,
      WholesaleUnitsPerCase,
      LoyaltyPoints,
      SupplierLoyaltyPoints,
      BonusLoyaltyPoints,
      Brand,
      Varietal,
      LiquorStyle,
      BrandRegion,
      BrandCountry,
      ReSizedDefaultImage,
      ItemsInCase,
      ProductType,
      ContainerType,
      IsCoreRange = false,
    } = Buyable
    let image = getProductsImage(Buyable)

    /**
     *  Create a unique key
     */
    const cartKey = generateSupplierCartKey(BuyableID, SupplierPromotionDiscount)

    /**
     *  Hide the cart item on checkout when the subtotal is 0
     */
    // if (Number(CalculatedSubTotalPrice) === 0) {
    //   return accumulator
    // }

    if (accumulator[cartKey] === undefined) {
      accumulator[cartKey] = {
        itemID: item.node.ID,
        isCore: null,
        isPromotion: null,
        title: Title,
        brand: Brand,
        varietal: Varietal,
        style: LiquorStyle,
        region: BrandRegion,
        country: BrandCountry,
        productID: BuyableID,
        qty_per_case: ItemsInCase,
        sell_by_case: 0,
        sku: InternalItemID,
        url_slug: URLSegment,
        caseTotal: 0,
        case_price: 0,
        unitTotal: 0,
        unit_price: 0,
        cartTotal: 0,
        wholesale_unit_per_case: WholesaleUnitsPerCase,
        loyaltyPoints: Number(LoyaltyPoints),
        supplierLoyaltyPoints: Number(SupplierLoyaltyPoints),
        bonusLoyaltyPoints: Number(BonusLoyaltyPoints),
        image,
        isCoreRange: getCoreRange(user?.enLocationID, IsCoreRange),
      }
    }

    accumulator[cartKey].cartTotal += Number(CalculatedSubTotalPrice)

    switch (item.node.BundleType) {
      case 'case':
        accumulator[cartKey].caseTotal += Number(TotalUnitItems)
        accumulator[cartKey].case_price += Number(UnitPrice)
        break
      case 'unit':
        accumulator[cartKey].unitTotal += Number(TotalUnitItems)
        accumulator[cartKey].unit_price += Number(UnitPrice)
        break
    }

    return accumulator
  }, {})

  return Object.values(list)
}

export const getIsCoreValue = (soldAt, user) => {
  let customerState = ''
  let currentCustomerState

  if (soldAt && typeof soldAt == 'string') {
    let finalSoldAt = soldAt.toLowerCase()

    if (finalSoldAt === 'm') {
      finalSoldAt = 'melbourne'
    } else if (finalSoldAt === 'a') {
      finalSoldAt = 'adelaide'
    }

    if (user?.state) {
      currentCustomerState = user?.state || ''
    } else {
      currentCustomerState = user?.details?.DeliveryAddress?.State || ''
    }

    switch (currentCustomerState.toLowerCase()) {
      case 'vic':
        customerState = 'melbourne'
        break
      case 'nsw':
        customerState = 'sydney'
        break
      case 'sa':
        customerState = 'adelaide'
        break
    }

    return finalSoldAt == 'all' || finalSoldAt.indexOf(customerState) != -1
  }

  return null
}
export const convertCheckoutDetailsToReact = (cart) => {
  //const rewardPoints = cart.Items.edges.reduce((accumulator, item) => accumulator + Number(item.node.PointsEarned), 0);

  return {
    id: cart.ID,
    shippingCost: cart.ShippingTotal,
    tax: cart.TaxTotal,
    subtotal: cart.SubTotal,
    //rewardPoints: rewardPoints || 0,
    total: cart.Total,
    pointsEarned: cart.PointsEarned,
    statusCredits: cart.StatusCredits,
    appliedSurchargeTotal: cart.AppliedSurchargeTotal,
    appliedSurcharges: cart.AppliedSurcharges?.nodes,
    discountTotal: cart.DiscountTotal,
    appliedDiscountCoupons: convertCheckoutCouponsToReadableFormat(cart.AppliedDiscountCoupon),
  }
}

export const convertCheckoutCouponsToReadableFormat = (coupon = {}) => {
  if (coupon?.DiscountCoupons?.edges?.length > 0) {
    return coupon?.DiscountCoupons?.edges?.map((code) => code.node)
  }

  return []
}

export const getCodeDateTypeText = (code) => {
  let codeList = [
    { key: 1, value: 'Expiration Date' },
    { key: 2, value: 'Born on Date' },
    { key: 3, value: 'Born on Code' },
    { key: 4, value: 'Expiration Code' },
  ]

  let found = codeList?.find((ele) => ele.key == code)
  if (found) {
    return found?.value
  } else {
    return code
  }
}

export const availableSellTypes = [
  { id: '0', label: 'Allow Sell By Consumable Units per Case' },
  { id: '1', label: 'Sell By Case Only' },
  { id: '2', label: 'Allow Decimals' },
]

export const getSellByCaseOnlyLabel = (type) => {
  let found = availableSellTypes?.find((ele) => ele.id == type)
  if (found) {
    return found?.label
  } else {
    return ''
  }
}

export const getSellByCaseOnlyID = (text) => {
  let found = availableSellTypes?.find((ele) => ele.label == text)
  if (found) {
    return found?.id
  } else {
    return ''
  }
}

export const convertProductMaintenanceDetailsToReact = (originalData, baseData) => {
  let list = []

  originalData = originalData.readOneProductMaintenanceRequest
  console.log('baseData , originalData', { originalData, originalData })

  const finalData = {
    ...baseData,
    id: originalData['InternalItemID'] || '',
    supplierProductNum: originalData['SupplierProductRef'] || '',
    Name: originalData['Name'] || '',
    productBrand: originalData['Brand'] || '',
    productDescription: originalData['Description'] || '',
    splitPackSize: originalData['SplitPackSize'] || '',
    size: originalData['Size'] || '',
    title: originalData['Title'] ? `${originalData['Title']}` : '',
    containerType: originalData['ContainerType'] || '',
    style: originalData['Style'] || '',
    country: originalData['Country'] || '',
    region: originalData['Region'] || '',
    webCategory: originalData['WebCategory' || ''],
    varietals: originalData['Varietals'] || '',
    abv: originalData['Abv'] ? parseFloat(originalData['Abv']) : 0,
    coldStorage: originalData['ColdStorage'] == 'YES' ? true : false,
    package: originalData['Package'] || '',
    unitsPerCase: originalData['UnitsPerCase'] || 0,
    caseUPC: originalData['CaseUPC'] ? parseFloat(originalData['CaseUPC']) : '',
    carrierUPC: originalData['CarrierUPC'] ? parseFloat(originalData['CarrierUPC']) : '',
    unitUPC: originalData['UnitUPC'] ? parseFloat(originalData['UnitUPC']) : '',
    productType: originalData['ProductType'] || '',
    casePrice: originalData['CasePrice'] ? parseFloat(originalData['CasePrice']) : 0,
    codeDateType: originalData['CodeDateType'] ? getCodeDateTypeText(originalData['CodeDateType']) : '',
    cartonWeight: originalData['CaseWeightInKG'] ? parseFloat(originalData['CaseWeightInKG']) : 0,
    dimensionHeight: originalData['Height'] ? parseFloat(originalData['Height']) : 0,
    dimensionWidth: originalData['Width'] ? parseFloat(originalData['Width']) : 0,
    dimensionLength: originalData['Length'] ? parseFloat(originalData['Length']) : 0,
    casesPerPallet: originalData['CasesPerPallet'] ? parseFloat(originalData['CasesPerPallet']) : 0,
    casesPerLayer: originalData['CasesPerLayer'] ? parseFloat(originalData['CasesPerLayer']) : 0,
    gstApplicable: originalData['GST'] || false,
    wetApplicable: originalData['WET'] || false,
    // levyNSW: originalData['ContainerDepositLevyNSW'] ? parseFloat(originalData['ContainerDepositLevyNSW']) : 0,
    // levySA: originalData['ContainerDepositLevySA'] ? parseFloat(originalData['ContainerDepositLevySA']) : 0,
    // levyQLD: originalData['ContainerDepositLevyQLD'] ? parseFloat(originalData['ContainerDepositLevyQLD']) : 0,
    isRemove: originalData['Removed'],
    Status: originalData['Status'] || 'Active',
    Is3PLOnly: originalData['Is3PLOnly'] || false,
    MarketingTag: originalData['MarketingTag'] ? 'Limited Release' : '',
    TrackVintages: originalData['TrackVintages'] || false,
    SellByCaseOnly: originalData['SellByCaseOnly'],
    HideOnWeb: originalData['HideOnWeb'] == 'YES' ? true : false,
    StockAvailableMelbourne: originalData['StockAvailableMelbourne'] || false,
    StockAvailableSydney: originalData['StockAvailableSydney'] || false,
    StockAvailableBrisbane: originalData['StockAvailableBrisbane'] || false,
    StockAvailableCairns: originalData['StockAvailableCairns'] || false,
    StockAvailableAdelaide: originalData['StockAvailableAdelaide'] || false,
    caseCostAdelaide: originalData['CaseCostAdelaide'] || 0,
    caseCostBrisbane: originalData['CaseCostBrisbane'] || 0,
    caseCostCairns: originalData['CaseCostCairns'] || 0,
    caseCostMelbourne: originalData['CaseCostMelbourne'] || 0,
    caseCostSydney: originalData['CaseCostSydney'] || 0,
    acceptedFiles: originalData?.['Images']?.edges.map((imageNode, key) => {
      const { ID, ReSizedProductDetailImage } = imageNode?.node
      return {
        id: ID,
        key,
        thumbnail: ReSizedProductDetailImage,
      }
    }),
    removedImages: [],
    rejectedFiles: [],

    stockForAdelaide: originalData?.['Product']?.['StockForAdelaide'] ? originalData['Product']['StockForAdelaide'] : 0,
    stockForBrisbane: originalData?.['Product']?.['StockForBrisbane'] ? originalData['Product']['StockForBrisbane'] : 0,
    stockForCairns: originalData?.['Product']?.['StockForCairns'] ? originalData['Product']['StockForCairns'] : 0,
    stockForMelbourne: originalData?.['Product']?.['StockForMelbourne']
      ? originalData['Product']['StockForMelbourne']
      : 0,
    stockForSydney: originalData?.['Product']?.['StockForSydney'] ? originalData['Product']['StockForSydney'] : 0,
  }

  list = [finalData]
  return list
}

export const convertProductMaintenanceDetailImagesToReact = (originalData) => {
  let list = []

  if (
    typeof originalData.readMysiteSupplierProductEditRequests != 'undefined' &&
    typeof originalData.readMysiteSupplierProductEditRequests.edges != 'undefined'
  ) {
    const edges = originalData.readMysiteSupplierProductEditRequests.edges

    list = edges.map((item, index) => {
      const node = item.node
      let finalData = {
        images: [],
      }

      // Do some adjustment
      for (let i = 1; i <= 5; i++) {
        const key = 'Image' + i
        if (typeof node[key] != 'undefined') {
          const imageNode = node[key]
          if (imageNode && imageNode.Link) {
            finalData.images.push({
              id: imageNode.ID,
              key: key,
              thumbnail: imageNode.Link,
            })
          }
        }
      }

      return finalData
    })
  }

  return list
}

export const convertProductMaintenanceDetailToPost = (originalData) => {
  const finalData = {
    SupplierProductRef: originalData['supplierProductNum'],
    Name: originalData['Name'],
    Brand: originalData['productBrand'],
    Description: window.productID
      ? titleCaseTextConverter(`${originalData['productDescription'] || ''}`)
      : titleCaseTextConverter(`${originalData['productDescription'] || ''} ${originalData['size'] || ''}`),
    Size: originalData['size'],
    SplitPackSize: originalData['splitPackSize'],
    Title: window.productID
      ? `${originalData['title'] || ''}`
      : `${originalData['productBrand'] ? originalData['productBrand']?.toUpperCase() : ''} ${
          originalData['productDescription'] ? originalData['productDescription']?.toUpperCase() : ''
        } ${!originalData['productid'] && originalData['size'] ? originalData['size'] : ''}`,
    ContainerType: originalData['containerType'],
    Style: originalData['style'],
    Country: originalData['country'],
    Region: originalData['region'],
    WebCategory: originalData['webCategory'] || '',
    Varietals: originalData['varietals'],
    Abv: originalData['abv'],
    ColdStorage: originalData['coldStorage'] ? 'YES' : 'NO',
    Package: originalData['package'],
    UnitsPerCase: parseInt(originalData['unitsPerCase'] || 0),
    CaseUPC: originalData['caseUPC'],
    CarrierUPC: originalData['carrierUPC'],
    UnitUPC: originalData['unitUPC'] ? originalData['unitUPC'] : '999999999',
    ProductType: originalData['productType'],
    CodeDateType: originalData['codeDateType'],
    StockAvailableAdelaide: originalData['StockAvailableAdelaide'],
    StockAvailableBrisbane: originalData['StockAvailableBrisbane'],
    StockAvailableCairns: originalData['StockAvailableCairns'],
    StockAvailableMelbourne: originalData['StockAvailableMelbourne'],
    StockAvailableSydney: originalData['StockAvailableSydney'],
    CaseWeightInKG: originalData['cartonWeight'],
    Height: originalData['dimensionHeight'],
    Width: originalData['dimensionWidth'],
    Length: originalData['dimensionLength'],
    CasesPerPallet: originalData['casesPerPallet'],
    CasesPerLayer: originalData['casesPerLayer'],
    GST: originalData['gstApplicable'],
    WET: originalData['wetApplicable'],
    MarketingTag: originalData['MarketingTag'] ? 'Limited Release' : '',
    TrackVintages: !!originalData['TrackVintages'],
    // ContainerDepositLevyNSW: originalData['levyNSW'],
    // ContainerDepositLevySA: originalData['levySA'],
    // ContainerDepositLevyQLD: originalData['levyQLD'],
    Removed: !!originalData['isRemove'],
    Images: originalData['images'],
    Status: originalData['Status'] || 'Active',
    Is3PLOnly: originalData['Is3PLOnly'] || false,
    SellByCaseOnly: originalData['SellByCaseOnly'],
    HideOnWeb: originalData['HideOnWeb'] ? 'YES' : 'NO',
    CasePriceAdelaide: originalData['PriceAdl'],
    CasePriceBrisbane: originalData['PriceBris'],
    CasePriceCairns: originalData['PriceCns'],
    CasePriceMelbourne: originalData['PriceMel'],
    CasePriceSydney: originalData['PriceSyd'],
    CaseCostAdelaide: originalData['caseCostAdelaide'],
    CaseCostBrisbane: originalData['caseCostBrisbane'],
    CaseCostCairns: originalData['caseCostCairns'],
    CaseCostMelbourne: originalData['caseCostMelbourne'],
    CaseCostSydney: originalData['caseCostSydney'],
  }
  return finalData
}

// export const convertThreePlCustomerDetailToPost = (originalData) => {
//   const finalData = {
//     ThreePLCustomerID: originalData['threePlId'] || '0',
//     CustomerName: originalData['customerName'] || '',
//     CustomerPhone: originalData['customerPhone'] || '',
//     CustomerEmail: originalData['customerEmail'] || '',
//     CreditTerms: originalData['creditTerms'] || 0,
//     DeliveryWindow: originalData['deliveryWindow'] || 0,
//     Address: originalData['address'],
//     Status: originalData['status'] || 0,
//     UnitNumber: originalData['unitNumber'],
//     StreetNumber: originalData['streetNumber'],
//     Suburb: originalData['suburb'],
//     State: originalData['state'],
//     PostalCode: originalData['postalCode'],
//     Country: originalData['country'],
//     LiquorLicenseNumber: originalData['liquorLicenseNumber'],
//     IsResidential: originalData['isResidential'] || false,
//     RequestAddToGlobalDB: originalData['isGlobalDatabase'] || true,
//   }

//   return finalData
// }

export const convertThreeEditPlCustomerDetailToPost = (originalData) => {
  const finalData = {
    ID: originalData['ID'],
    ThreePLCustomerID: originalData['internalItemID'] || '0',
    CustomerName: originalData['customerName'] || '',
    CustomerPhone: originalData['customerPhone'] || '',
    CustomerEmail: originalData['customerEmail'] || '',
    CreditTermsID: originalData['creditTermsID'] || 0,
    CreditTerms: originalData['creditTerms'] || '',
    DeliveryWindow: originalData['deliveryWindow'] || 0,
    Address: getAddressValue(originalData),
    // Status: originalData['status'] || 0,
    UnitNumber: originalData['unitNumber'],
    StreetNumber: originalData['streetNumber'],
    StreetName: originalData['streetName'],
    PreferedDeliveryTime: originalData['preferedDeliveryTime'] || '',
    PreferedDeliveryDay: originalData['preferedDeliveryDay'] || '',
    DeliveryNotes: originalData['deliveryNotes'] || '',
    Suburb: originalData['suburb'],
    State: originalData['state'],
    PostalCode: originalData['postalCode'],
    Country: originalData['country'],
    LiquorLicenseNumber: originalData['licenceNumber'] || '',
    IsResidential: originalData['isResidential'] || false,
    // RequestAddToGlobalDB: originalData['isGlobalDatabase'] || true,
  }

  return finalData
}

export const convertThreePlCustomerDetailToPost = (originalData) => {
  const finalData = {
    ThreePLCustomerID: originalData['threePlId'] || '0',
    CustomerName: originalData['customerName'] || '',
    CustomerPhone: originalData['customerPhone'] || '',
    CustomerEmail: originalData['customerEmail'] || '',
    CreditTerms: originalData['creditTerms'] || 0,
    CreditTermsID: originalData['creditTermsID'] || 0,
    DeliveryWindow: originalData['preferred_delivery_day'] || 0,
    PreferedDeliveryTime: originalData['preferedDeliveryTime'] || '',
    PreferedDeliveryDay: originalData['preferedDeliveryDay'] || '',
    DeliveryNotes: originalData['deliveryNotes'] || '',
    Address: getAddressValue(originalData),
    // Status: originalData['status'] || '1',
    UnitNumber: originalData['unitNumber'],
    StreetNumber: originalData['streetNumber'],
    StreetName: originalData['streetName'],
    Suburb: originalData['suburb'],
    State: originalData['state'],
    PostalCode: originalData['postalCode'],
    Country: originalData['country'],
    LiquorLicenseNumber: originalData['licenceNumber'],
    IsResidential: originalData['isResidential'] || false,
    // RequestAddToGlobalDB: originalData['isGlobalDatabase'] || true,
  }

  return finalData
}

export function getAddressValue(originalData) {
  return `${
    originalData['unitNumber'] !== '' && originalData['unitNumber'] !== null ? originalData['unitNumber'] + ',' : ''
  } ${originalData['streetNumber']} ${originalData['streetName']} ${originalData['suburb']}`
}

export const convertThreePlUpdateProductAvailabilityTypeToPost = (originalData) => {
  const finalData = {
    ProductID: originalData['id'],
    [originalData['name']]: originalData['value'],
  }

  return finalData
}

export const convertDeleteThreePlCustomerDetailToPost = (originalData) => {
  const finalData = {
    ID: originalData['threePlId'],
    ThreePLCustomerID: originalData['threePlId'] || '0',
    CustomerName: originalData['customerName'] || '',
    CustomerPhone: originalData['customerPhone'] || '',
    CustomerEmail: originalData['customerEmail'] || '',
    CreditTerms: originalData['creditTerms'] || 0,
    DeliveryWindow: originalData['deliveryWindow'] || 0,
    Address: originalData['address'],
    Status: originalData['status'] || 0,
    UnitNumber: originalData['unitNumber'],
    StreetNumber: originalData['streetNumber'],
    Suburb: originalData['suburb'],
    State: originalData['state'],
    PostalCode: originalData['postalCode'],
    Country: originalData['country'],
    LiquorLicenseNumber: originalData['liquorLicenseNumber'],
    IsResidential: originalData['isResidential'] || false,
    // RequestAddToGlobalDB: originalData['isGlobalDatabase'] || true,
    PermanentDeleteLocalCustomer: true,
  }

  return finalData
}

export const convertProduct3plToReact = (originalData, baseData) => {
  const mapping = new Map([
    ['id', 'id'],
    ['title', 'name'],
    ['description', 'description'],
  ])

  let convertedData = {}

  // Convert data based on the mapping
  mapping.forEach((requestKey, reactKey) => {
    if (typeof originalData[requestKey] != 'undefined') {
      convertedData[reactKey] = originalData[requestKey]
    }
  })

  const data = {
    ...baseData,
    ...convertedData,
  }

  return data
}
export const convertProducts3plToReact = (list) => {
  const mapping = new Map([])

  // Convert data based on the mapping
  const newList = list.map((item) => {
    let convertedData = { ...item }

    mapping.forEach((requestKey, reactKey) => {
      if (typeof item[requestKey] != 'undefined') {
        convertedData[reactKey] = item[requestKey]
        delete convertedData[requestKey]
      }
    })

    return convertedData
  })

  return newList
}
export const combine3plProducts = (products, userInput) => {
  let newProducts = { ...products }
  Object.entries(userInput).forEach(([key, value]) => {
    if (typeof newProducts[key] != 'undefined') {
      newProducts[key] = {
        ...newProducts[key],
        ...value,
      }
    }
  })

  return Object.values(newProducts)
}
export const combineSupplierProducts = (products, userInput) => {
  let newProducts = { ...products }
  Object.entries(userInput).forEach(([key, value]) => {
    if (typeof newProducts[key] != 'undefined') {
      newProducts[key] = {
        ...newProducts[key],
        ...value,
      }

      let {
        calculatedSOH,
        soh,
        qty_per_case,
        sell_by_case,
        caseQty,
        unitQty,
        caseBackOrder,
        unitBackOrder,
        cartQty,
        backOrderQty,
      } = newProducts[key]

      if (soh != calculatedSOH) {
        const sohDifference = cartQty - calculatedSOH

        if (sell_by_case) {
          if (cartQty >= calculatedSOH) {
            caseQty = calculatedSOH
            caseBackOrder += sohDifference
            cartQty = calculatedSOH
            backOrderQty += sohDifference

            newProducts[key] = {
              ...newProducts[key],
              caseQty: caseQty,
              caseBackOrder: caseBackOrder,
              cartQty: cartQty,
              backOrderQty: backOrderQty,
            }
          }
        } else {
          if (cartQty >= calculatedSOH) {
            unitQty = calculatedSOH
            unitBackOrder += sohDifference
            cartQty = calculatedSOH
            backOrderQty += sohDifference

            caseQty = caseQty + Math.floor(unitQty / qty_per_case)
            unitQty = unitQty % qty_per_case

            caseBackOrder = caseBackOrder + Math.floor(caseBackOrder / qty_per_case)
            unitBackOrder = unitBackOrder % qty_per_case

            newProducts[key] = {
              ...newProducts[key],
              caseQty: caseQty,
              unitQty: unitQty,
              caseBackOrder: caseBackOrder,
              unitBackOrder: unitBackOrder,
              cartQty: cartQty,
              backOrderQty: backOrderQty,
            }
          }
        }
      }
    }
  })

  return Object.values(newProducts)
}
export const getCalculatedCartSOH = (cartList, requestedProductID) => {
  let cartProducts = {}
  let calculatedSOH = 0

  // Get the user input case total & unit totals
  Object.entries(cartList).forEach(([key, value]) => {
    const { productID, soh, sell_by_case, qty_per_case } = value
    if (productID == requestedProductID) {
      if (typeof cartProducts[productID] == 'undefined') {
        cartProducts[productID] = {
          soh: soh || 0,
          sell_by_case: sell_by_case,
          qty_per_case: qty_per_case,
          caseTotal: value.caseTotal,
          unitTotal: value.unitTotal,
        }
      } else {
        cartProducts[productID].caseTotal += value.caseTotal
        cartProducts[productID].unitTotal += value.unitTotal
      }
    }
  })

  if (typeof cartProducts[requestedProductID] != 'undefined') {
    const { soh, sell_by_case, qty_per_case, caseTotal, unitTotal } = cartProducts[requestedProductID]

    if (sell_by_case) {
      calculatedSOH = soh - caseTotal
    } else {
      const currentCartQty = qty_per_case * caseTotal + unitTotal
      calculatedSOH = soh - currentCartQty
    }

    if (calculatedSOH < 0) {
      calculatedSOH = 0
    }
  }

  return calculatedSOH
}
export const updateAvailableQty = (productList, cartList) => {
  let newProducts = JSON.parse(JSON.stringify(productList))
  let cartProducts = {}

  // Get the user input case total & unit totals
  Object.entries(cartList).forEach(([key, value]) => {
    const { productID } = value
    if (typeof cartProducts[productID] == 'undefined') {
      cartProducts[productID] = {
        caseTotal: value.caseTotal || 0,
        unitTotal: value.unitTotal || 0,
      }
    } else {
      cartProducts[productID].caseTotal += value.caseTotal
      cartProducts[productID].unitTotal += value.unitTotal
    }
  })

  Object.entries(cartProducts).forEach(([key, value]) => {
    if (typeof newProducts[key] != 'undefined') {
      const { soh, sell_by_case, qty_per_case } = newProducts[key]
      const cartItemBookKeeper = cartProducts[key]

      const currentCartQty = qty_per_case * cartItemBookKeeper.caseTotal + cartItemBookKeeper.unitTotal
      newProducts[key].calculatedSOH = soh - currentCartQty

      if (newProducts[key].calculatedSOH < 0) {
        newProducts[key].calculatedSOH = 0
      }
    }
  })

  return newProducts
}
export const getBaseCartItemStructure = () => {
  return {
    cartTotal: 0,
    case_price: 0,
    caseQty: 0,
    caseTotal: 0,
    unit_price: 0,
    unitQty: 0,
    unitTotal: 0,
    sell_by_case: false,
    qty_per_case: 1,
    url_slug: '',
    title: '',
  }
}
export const buildSupplierCartList = (product, userInput) => {
  let cartList = {}

  Object.entries(userInput).map(([key, item]) => {
    if (typeof product[key] != 'undefined') {
      const cartItem = buildSupplierCartItem(product[key], item)
      cartList[cartItem.cartID] = cartItem
    }
  })

  return cartList
}
export const buildSupplierCartItem = (product, userInput) => {
  const baseData = getBaseCartItemStructure()
  let cartItem = { ...baseData }

  if (product && userInput) {
    const { lastKey, lastValue, flatDiscountValue } = userInput
    let promotionType

    /**
     *  Use flat discount at the moment
     *  https://jira.visualr.dev/browse/PAR-1513
     */
    promotionType = 3

    /**
     * SupplierPromotionDiscount (promotionDiscount) should always be flat case discount
     */
    cartItem = {
      case_price: 0,
      unit_price: 0,
      ...product,
      ...userInput,
      promotionType: promotionType,
      promotionDiscount: flatDiscountValue,
    }

    // Move this into case price
    if (typeof cartItem.casePriceValue != 'undefined') {
      cartItem.case_price = cartItem.casePriceValue
    }
    if (typeof cartItem.unitPriceValue != 'undefined') {
      cartItem.unit_price = cartItem.unitPriceValue
    }

    delete cartItem.lastKey
    delete cartItem.lastValue
    delete cartItem.flatDiscountValue
    delete cartItem.percentageDiscountValue
    delete cartItem.casePriceValue
    delete cartItem.unitPriceValue

    // Update the ID
    const { id, case_price } = cartItem

    cartItem.cartID = buildSupplierCartItemKey(id, case_price)
  }

  return cartItem
}
export const buildSupplierCartItemKey = (productID, case_price) => {
  if (typeof case_price !== 'string') {
    case_price = case_price.toString()
  }

  case_price = parseFloat(case_price).toFixed(2)

  let key = productID + '_' + case_price

  return key
}
export const build3plCartList = (products, cart) => {
  const baseData = getBaseCartItemStructure()
  let cartList = {}
  Object.entries(cart).forEach(([key, value]) => {
    let cartItem = {
      ...baseData,
      ...products[key],
      ...value,
    }

    if (cartItem.qty_per_case) {
      cartItem.unit_price = cartItem.case_price / cartItem.qty_per_case
    }

    cartList[key] = cartItem
  })

  return cartList
}
export const appendCartList = (masterCartList, newCartList) => {
  let cartList = { ...masterCartList }
  Object.entries(newCartList).forEach(([key, value]) => {
    if (typeof cartList[key] != 'undefined') {
      cartList[key].caseQty += value.caseQty
      cartList[key].unitQty += value.unitQty
    } else {
      cartList[key] = { ...value }
    }

    // Double check if the quantity is not 0 for any
    if (cartList[key].caseQty == 0 && cartList[key].unitQty == 0) {
      delete cartList[key]
    }
  })

  return cartList
}
export const appendCartListWithBackOrder = (masterCartList, newCartList) => {
  let cartList = { ...masterCartList }
  Object.entries(newCartList).forEach(([key, value]) => {
    if (typeof cartList[key] != 'undefined') {
      cartList[key].caseQty += value.caseQty
      cartList[key].unitQty += value.unitQty
      cartList[key].caseBackOrder += value.caseBackOrder
      cartList[key].unitBackOrder += value.unitBackOrder
      cartList[key].caseTotal += value.caseTotal
      cartList[key].unitTotal += value.unitTotal
    } else {
      cartList[key] = { ...value }
    }

    // Double check if the quantity is not 0 for any
    if (
      (typeof cartList[key].caseTotal == 'undefined' && typeof cartList[key].unitTotal == 'undefined') ||
      (cartList[key].caseTotal == 0 && cartList[key].unitTotal == 0)
    ) {
      delete cartList[key]
    }
  })

  return cartList
}
export const convertDumbCartToSmartCart = (cart) => {
  const mapping = new Map([
    ['case_price', 'casePrice'],
    ['unit_price', 'unitPrice'],
    // ['caseTotal', 'caseQty'],
    // ['unitTotal', 'unitQty'],
    ['qty_per_case', 'qtyPerCase'],
    ['cartTotal', 'total'],
  ])

  const defaultCart = {
    cartTotal: 0,
    case_price: 0,
    caseQty: 0,
    unitQty: 0,
    unit_price: 0,
  }

  let newCart = {
    ...cart,
  }

  Object.entries(cart).forEach(([key, value]) => {
    if (typeof newCart[key] != 'undefined') {
      newCart[key] = {
        ...defaultCart,
        ...newCart[key],
      }

      // Convert data based on the mapping
      mapping.forEach((requestKey, reactKey) => {
        if (typeof newCart[key][requestKey] != 'undefined') {
          newCart[key][reactKey] = newCart[key][requestKey]
          // delete newCart[key][requestKey];
        }
      })
    }

    // TODO
    // if (newCart[key].qty_per_case) {
    //   newCart[key].unit_price = newCart[key].case_price / newCart[key].qty_per_case
    // }
  })

  return newCart
}
export const cleanCartItem = (data, product, type) => {
  let { caseQty, unitQty } = data
  const { qty_per_case, soh, sell_by_case } = product

  if (sell_by_case) {
    if (caseQty > 0) {
      if (soh < caseQty) {
        caseQty = soh
      }
    } else {
      caseQty = 0
    }
  } else {
    const currentTotal = caseQty * qty_per_case + unitQty

    if (soh < currentTotal) {
      caseQty = Math.floor(soh / qty_per_case)
      unitQty = soh % qty_per_case
    } else {
      if (unitQty >= qty_per_case) {
        caseQty = caseQty + Math.floor(unitQty / qty_per_case)
        unitQty = unitQty % qty_per_case
      } else if (unitQty < 0) {
        if (caseQty > 0) {
          unitQty = qty_per_case - 1
        }

        caseQty = caseQty - 1
      }
    }
  }

  if (caseQty < 0) {
    caseQty = 0
  }
  if (unitQty < 0) {
    unitQty = 0
  }

  data.unitQty = unitQty
  data.caseQty = caseQty

  if (type == 'cart') {
    data.caseTotal = caseQty
    data.unitTotal = unitQty

    // Finalise cartTotal
    data.cartTotal = getCartItemTotal(data)
  }

  return data
}
/**
 * Adjust the supplier & 3PL cart item after modifying the quantity
 *
 * @param data
 * @param product
 * @param type
 * @returns {{caseBackOrder: *, unitBackOrder: *, caseQty: *, caseTotal: *, unitQty: *, backOrderQty: *, unitTotal: *, cartQty: *}}
 */
export const cleanCartItemWithBackOrder = (data, product, type) => {
  const ALLOW_BACKORDER = false
  const ALLOW_EXCEEDING_STOCK = true

  const { qty_per_case, soh, sell_by_case } = product
  const defaultDataTemplate = {
    caseQty: 0,
    unitQty: 0,
    caseBackOrder: 0,
    unitBackOrder: 0,
    caseTotal: 0,
    unitTotal: 0,
    cartQty: 0,
    backOrderQty: 0,
  }

  let finalData = {
    ...defaultDataTemplate,
    ...data,
  }

  let {
    cartQty,
    backOrderQty,
    caseBackOrder,
    unitBackOrder,
    caseQty,
    unitQty,
    caseTotal,
    unitTotal,
    calculatedSOH,
  } = finalData
  let finalSOH = calculatedSOH !== undefined ? calculatedSOH : soh

  /**
   * Get rid of unit to case conversion
   * Handle input of caseTotal and unitTotal, fallback (lock) the total to 1
   */
  if (type === 'cart') {
    if (caseTotal <= 0) {
      caseTotal = 1
    }
    if (unitTotal <= 0) {
      unitTotal = 1
    }
  }

  // Now handle the qty
  caseQty = caseTotal
  unitQty = unitTotal

  if (sell_by_case) {
    const availableSohBasedOnCase = Math.floor(finalSOH / qty_per_case)
    if (availableSohBasedOnCase < caseQty) {
      caseQty = availableSohBasedOnCase
    }
  } else {
    const currentTotal = caseQty * qty_per_case + unitQty

    if (finalSOH < currentTotal) {
      caseQty = Math.floor(finalSOH / qty_per_case)
      unitQty = finalSOH % qty_per_case
    } else {
      if (unitQty >= qty_per_case) {
        caseQty = caseQty + Math.floor(unitQty / qty_per_case)
        unitQty = unitQty % qty_per_case
      } else if (unitQty < 0) {
        if (caseQty > 0) {
          unitQty = qty_per_case - 1
        }

        caseQty = caseQty - 1
      }
    }
  }

  // Handle backorder
  if (ALLOW_BACKORDER) {
    caseBackOrder = caseTotal - caseQty
    unitBackOrder = unitTotal - unitQty

    if (sell_by_case) {
      cartQty = caseQty
      backOrderQty = caseBackOrder
    } else {
      cartQty = caseQty * qty_per_case + unitQty
      backOrderQty = caseBackOrder * qty_per_case + unitBackOrder
    }
  } else if (ALLOW_EXCEEDING_STOCK) {
    // Do nothing
  } else {
    // Revert
    caseTotal = caseQty
    unitTotal = unitQty
  }

  finalData = {
    ...finalData,
    caseQty: caseQty,
    unitQty: unitQty,
    caseBackOrder: caseBackOrder,
    unitBackOrder: unitBackOrder,
    caseTotal: caseTotal,
    unitTotal: unitTotal,
    cartQty: cartQty,
    backOrderQty: backOrderQty,
  }

  if (type == 'cart') {
    // Finalise cartTotal
    finalData.cartTotal = getCartItemTotal(finalData)
  }

  return finalData
}
export const adjustDumbCartWithBackOrder = (originalCart) => {
  let sohProductMapping = {}
  let productPriceData = {}
  let cart = {
    ...originalCart,
  }

  // Preparation before doing the heavy lifting
  Object.values(cart).map((cartItem) => {
    const { id, soh, case_price } = cartItem
    const finalCasePrice = parseFloat(case_price)

    // Get the SOH of each product
    sohProductMapping[id] = soh

    // Get the mapping of product x price
    if (typeof productPriceData[id] == 'undefined') {
      productPriceData[id] = []
    }

    productPriceData[id].push(finalCasePrice)
  })

  // Now let's work on it
  Object.entries(productPriceData).forEach(([id, productPrices]) => {
    // Sort descending order
    productPrices.sort((a, b) => b - a)

    // And now let's work on it
    productPrices.map((productCasePrice) => {
      const cartItemKey = buildSupplierCartItemKey(id, productCasePrice)

      // Get cart item
      let cartItem = { ...cart[cartItemKey] }

      const { sell_by_case, qty_per_case } = cartItem
      let { caseBackOrder, caseQty, unitBackOrder, unitQty, cartQty, backOrderQty } = cartItem

      const totalInput = cartQty + backOrderQty

      // Calculate
      if (sohProductMapping[id] >= totalInput) {
        sohProductMapping[id] -= totalInput
        cartQty = totalInput
        backOrderQty = 0
      } else {
        cartQty = sohProductMapping[id]
        backOrderQty = totalInput - sohProductMapping[id]
        sohProductMapping[id] = 0
      }

      // Deduct soh
      if (sell_by_case) {
        cart[cartItemKey] = {
          ...cartItem,
          caseQty: cartQty,
          caseBackOrder: backOrderQty,
          unitQty: 0,
          unitBackOrder: 0,
          cartQty: cartQty,
          backOrderQty: backOrderQty,
        }
      } else {
        // Calculation for cart
        if (cartQty > 0) {
          caseQty = Math.floor(cartQty / qty_per_case)
          unitQty = cartQty % qty_per_case
        } else {
          caseQty = 0
          unitQty = 0
        }

        // Calculation for back order
        if (backOrderQty > 0) {
          caseBackOrder = Math.floor(backOrderQty / qty_per_case)
          unitBackOrder = backOrderQty % qty_per_case
        } else {
          caseBackOrder = 0
          unitBackOrder = 0
        }

        cart[cartItemKey] = {
          ...cartItem,
          caseQty: caseQty,
          caseBackOrder: caseBackOrder,
          unitQty: unitQty,
          unitBackOrder: unitBackOrder,
          cartQty: cartQty,
          backOrderQty: backOrderQty,
        }
      }
    })
  })

  return cart
}
export const convertActiveCustomerToReact = (originalData) => {
  return convertMembersToReact(originalData)
}
export const convert3plActiveCustomerToReact = (originalData) => {
  const list = convert3plCustomersToReact(originalData, null)

  if (list.length) {
    return list.pop()
  }

  return {}
}
export const generateFullAddress = (addressObj, separator) => {
  let fullAddressData = []
  let brokenDownAddress = ''
  let combinedAddress = ''
  let combinedStatePostcode = ''

  if (typeof separator == 'undefined' || separator == '') {
    separator = ', '
  }

  const { unitNumber, streetNumber, streetNumber2, streetName, suburb, state, postcode, country } = addressObj
  let { address } = addressObj

  // Combine Broken Down Address into one
  if (streetNumber && streetNumber2) {
    brokenDownAddress = streetNumber + '-' + streetNumber2
  } else if (streetNumber) {
    brokenDownAddress = streetNumber
  } else if (streetNumber2) {
    brokenDownAddress = streetNumber2
  }

  if (streetName) {
    brokenDownAddress = (brokenDownAddress + ' ' + streetName).trim()
  }

  // Overwrite address to broken down address
  if (brokenDownAddress) {
    address = brokenDownAddress
  }

  // Combine Unit Number & Address
  if (unitNumber && address) {
    combinedAddress = unitNumber + ', ' + address
  } else if (unitNumber) {
    combinedAddress = unitNumber
  } else if (address) {
    combinedAddress = address
  }

  if (combinedAddress) {
    fullAddressData.push(combinedAddress)
  }

  // Combine Suburb
  if (suburb) {
    fullAddressData.push(suburb)
  }

  // Combine State & Postcode
  if (state && postcode) {
    combinedStatePostcode = state + ' ' + postcode
  } else if (state) {
    combinedStatePostcode = state
  } else if (postcode) {
    combinedStatePostcode = postcode
  }

  if (combinedStatePostcode) {
    fullAddressData.push(combinedStatePostcode)
  }

  // Combine Country
  if (country) {
    fullAddressData.push(country)
  }

  return fullAddressData.join(separator)
}
export const convertAddressToReactSelect = (addresses) => {
  const convertedData = addresses.map((item) => {
    return {
      value: item.id,
      label: generateFullAddress(item, ', '),
    }
  })

  return convertedData
}
export const convert3plCustomerAddressToAvailableAddress = (data) => {
  const mapping = ['unitNumber', 'address', 'suburb', 'state', 'postcode', 'country']

  let newData = {}

  mapping.map((requestKey) => {
    if (typeof data[requestKey] != 'undefined') {
      newData[requestKey] = data[requestKey]
    }
  })

  return newData
}
export const convertAvailableDeliveryAddressesToReact = (originalData) => {
  let list = []

  if (typeof originalData != 'undefined' && originalData.length > 0) {
    list = originalData.map((item, index) => {
      return convertAvailableDeliveryAddressToReact(item.node)
    })
  }

  return list
}
export const convertAvailableDeliveryAddressToReact = (originalData) => {
  const mapping = new Map([
    ['id', 'ID'],
    ['fulladdress', 'FullAddress'],
    ['unitNumber', 'UnitNumber'],
    ['streetNumber', 'StreetNumber'],
    ['streetNumber2', 'StreetNumber_2'],
    ['streetName', 'StreetName'],
    ['address', 'Address'],
    ['suburb', 'Suburb'],
    ['state', 'State'],
    ['postcode', 'PostalCode'],
    ['country', 'Country'],
    ['isDefault', 'IsDefault'],
    ['enDefaultltAddress', 'EnDefaultAddress'],
  ])

  // Convert data based on the mapping
  let newData = {}
  mapping.forEach((requestKey, reactKey) => {
    if (typeof originalData[requestKey] != 'undefined') {
      newData[reactKey] = originalData[requestKey]
    }
  })

  return newData
}
export const convertAvailableDeliveryDatesToReact = (originalData) => {
  let list = []

  if (
    typeof originalData.readAppDeliveryDates != 'undefined' &&
    typeof originalData.readAppDeliveryDates.edges != 'undefined'
  ) {
    const edges = originalData.readAppDeliveryDates.edges

    list = edges.map((item, index) => {
      const node = item.node

      // return node.Date;
      return {
        date: node.Date,
        available: node.Available === 'true',
        consolidationDay: node.ConsolidationDay,
      }
    })
  }

  return list
}
export const createDummyAvailableDeliveryDates = () => {
  let list = []

  let currentDate = moment().add(1, 'days')

  for (let i = 0; i < 20; i++) {
    list.push({
      date: currentDate.format('YYYY-MM-DD'),
      available: true,
      consolidationDay: false,
    })

    currentDate.add(1, 'days')
  }

  return list
}
export const convertDiscountProductsToOngoingDeal = (originalData) => {
  let data = {
    ...originalData,
    modifiedRows: {},
  }

  data.items.map((item) => {
    const { originalPrice, discountedPrice } = item
    let flatDiscountValue = originalPrice - discountedPrice
    let percentageDiscountValue = ((originalPrice - discountedPrice) / originalPrice) * 100

    data.modifiedRows[item.id] = {
      lastKey: 'case_price',
      lastValue: discountedPrice,
      casePriceValue: parseFloat(discountedPrice).toFixed(2),
      flatDiscountValue: parseFloat(flatDiscountValue).toFixed(2),
      percentageDiscountValue: parseFloat(percentageDiscountValue).toFixed(2),
      originalCasePrice: originalPrice,
    }
  })

  delete data.items

  return data
}
export const convertDiscountsToReact = (originalData) => {
  let list = []

  // Basic mapping
  const mapping = new Map([
    ['id', 'ID'],
    ['title', 'Title'],
    // ['promotionType', 'PromotionType'],
    ['dateFrom', 'FromDate'],
    ['dateTo', 'ToDate'],
  ])

  const now = moment()

  if (typeof originalData.readDiscounts != 'undefined' && typeof originalData.readDiscounts.edges != 'undefined') {
    const edges = originalData.readDiscounts.edges

    list = edges.map((item, index) => {
      const node = item.node
      let finalData = {
        originalSort: index,
      }

      // Convert data based on the mapping
      mapping.forEach((requestKey, reactKey) => {
        if (typeof node[requestKey] != 'undefined') {
          finalData[reactKey] = node[requestKey]
        }
      })

      // Convert Assigned Customers Groups
      if (typeof node['Customers'] != 'undefined') {
        finalData['assignedCustomers'] = convertCustomerNameEdgesToReactSelect(node['Customers'])
      }

      // Convert Assigned Products Groups
      if (typeof node['Items'] != 'undefined') {
        finalData['items'] = node['Items'].edges.map((item, index) => {
          const { node } = item
          const { Amount, DiscountType, Product } = node

          return {
            id: Product.ID,
            productID: Product.ID,
            title: Product.Title,
            discountedPrice: Amount,
            promotionType: DiscountType,
          }
        })
      }

      // Do some adjustment
      const dateFrom = moment(finalData['dateFrom'], 'YYYY-MM-DD HH:mm:ss')
      const dateTo = moment(finalData['dateTo'], 'YYYY-MM-DD HH:mm:ss')

      // TODO: Remove status & enabled when it's finalised
      // finalData.enabled = finalData.dateTo === null ? 0 : 1;
      // if(finalData.enabled) {
      //     if(finalData.dateFrom === null) {
      //         finalData.status = now.isBefore(dateTo) ? 'Active' : 'Expired';
      //     }
      //     else {
      //         finalData.status = now.isBetween(dateFrom, dateTo) ? 'Active' : 'Expired';
      //     }
      // }
      // else {
      //     finalData.status = 'Disabled';
      // }

      finalData.dateFrom = dateFrom.format('DD/MM/YYYY')
      finalData.dateTo = dateTo.format('DD/MM/YYYY')

      // Keep a copy
      // TODO: Remove status & enabled when it's finalised
      // finalData.originalEnabledStatus = finalData.enabled;

      return finalData
    })
  }

  return list
}
export const convert3plOrdersToReact = (originalData) => {
  let list = []

  // Basic mapping
  const mapping = new Map([
    ['id', 'ID'],
    ['placed', 'Placed'],
    ['deliveryDate', 'DeliveryDate'],
    ['total', 'Total'],
    ['tax', 'Tax'],
    ['reference', 'Reference'],
    ['status', 'Status'],
    ['total', 'Total'],
  ])

  // Order items mapping
  const orderItemsMapping = new Map([
    ['id', 'ID'],
    ['title', 'Title'],
    ['sku', 'InternalItemID'],
    ['qty_per_case', 'ConsumableUnitsPerCase'],
    ['sell_by_case', 'SellByCaseOnly'],
    ['unitTotal', 'UnitQuantity'],
    ['caseTotal', 'CaseQuantity'],
    ['case_price', 'CasePrice'],
    ['unit_price', 'UnitPrice'],
    ['totalPrice', 'TotalPrice'],
  ])

  if (
    typeof originalData.readElvantiOrders != 'undefined' &&
    typeof originalData.readElvantiOrders.edges != 'undefined'
  ) {
    const edges = originalData.readElvantiOrders.edges

    list = edges.map((item, index) => {
      const node = item.node
      const { PlCustomer } = node
      let finalData = {
        customerName: typeof PlCustomer.Name != 'undefined' ? PlCustomer.Name : '',
        deliverySuburb: typeof PlCustomer.Suburb != 'undefined' ? PlCustomer.Suburb : '',
      }

      // Convert data based on the mapping
      mapping.forEach((requestKey, reactKey) => {
        if (typeof node[requestKey] != 'undefined') {
          finalData[reactKey] = node[requestKey]
        }
      })

      // Order Items Mapping
      if (typeof node['OrderItems'] != 'undefined') {
        finalData['orderItems'] = node['OrderItems'].edges.map((item, index) => {
          const node = item.node
          let finalData = {}

          orderItemsMapping.forEach((requestKey, reactKey) => {
            if (typeof node[requestKey] != 'undefined') {
              finalData[reactKey] = node[requestKey]
            }
          })

          return finalData
        })
      } else {
        finalData['orderItems'] = []
      }

      // Do some adjustment
      finalData['placed'] = moment(new Date(finalData['placed'])).format('DD/MM/YYYY')
      finalData['deliveryDate'] = moment(new Date(finalData['deliveryDate'])).format('DD/MM/YYYY')

      return finalData
    })
  }

  return list
}
export const convert3plCustomersToReact = (originalData, baseEditLink) => {
  let list = []

  // Basic mapping
  const mapping = new Map([
    ['id', 'ID'],
    ['name', 'Name'],
    ['email', 'Email'],
    ['address', 'Address'],
    ['suburb', 'Suburb'],
    ['postcode', 'Postcode'],
    ['state', 'State'],
    ['contactName', 'ContactName'],
    ['phone', 'ContactNumber'],
  ])

  if (typeof originalData.readPlCustomers != 'undefined' && typeof originalData.readPlCustomers.edges != 'undefined') {
    const edges = originalData.readPlCustomers.edges

    list = edges.map((item, index) => {
      const node = item.node
      let finalData = {}

      // Convert data based on the mapping
      mapping.forEach((requestKey, reactKey) => {
        if (typeof node[requestKey] != 'undefined') {
          finalData[reactKey] = node[requestKey]
        }
      })

      // Do some adjustment
      if (baseEditLink) {
        if (baseEditLink.substr(-1) != '/') {
          baseEditLink += '/'
        }

        finalData.editLink = baseEditLink + finalData.id
      }

      return finalData
    })
  }

  return list
}
export const convertMembersToReact = (originalData) => {
  // Basic mapping
  const mapping = new Map([
    ['id', 'ID'],
    ['firstName', 'FirstName'],
    ['surname', 'Surname'],
    ['email', 'Email'],
    ['defaultDeliveryAddressID', 'DefaultDeliveryAddressID'],
    ['defaultCreditCardID', 'DefaultSavedCreditCardID'],
    // ['warehouse', 'WarehouseID'],
    // Add New Fields for Customer Title Update
    ['state', 'State'],
    ['company', 'Company'],
    ['internalItemID', 'InternalItemID'],
    ['suburb', 'EnCity'],
  ])

  const node = { ...originalData }
  let finalData = {}

  // Convert data based on the mapping
  mapping.forEach((requestKey, reactKey) => {
    if (typeof node[requestKey] != 'undefined') {
      finalData[reactKey] = node[requestKey]
    }
  })

  if (node?.DeliveryAddress) {
    finalData.defaultDeliveryAddressID = node?.DeliveryAddress?.ID
    finalData.state = node?.DeliveryAddress?.State
  }

  if (node?.SavedCreditCard) {
    finalData.defaultCreditCardID = node?.SavedCreditCard?.ID
  }

  // Do some adjustment
  const { firstName, surname } = finalData
  let name = ''

  if (firstName) {
    name += firstName
  }
  if (surname) {
    name += ' ' + surname
  }

  finalData.name = name.trim()

  return finalData
}
export const getDumbCartForMember = (list, customerID) => {
  return typeof list[customerID] != 'undefined' ? list[customerID] : {}
}
export const buildNewAddressData = (originalData, memberID) => {
  const { unitNumber, streetNumber, streetNumber2, streetName, suburb, postcode, state, country } = originalData

  let finalData = {
    MemberID: memberID,
    UnitNumber: unitNumber,
    StreetNumber: streetNumber,
    StreetNumber_2: streetNumber2,
    StreetName: streetName,
    Suburb: suburb,
    State: state,
    PostalCode: postcode,
    Country: country,
  }

  return finalData
}
export const convertAvailableCreditCardsToReact = (originalData) => {
  let list = []

  if (typeof originalData != 'undefined' && originalData.length) {
    list = originalData.map((node, index) => {
      return {
        value: node.ID,
        label: node.Title,
        expiryMonth: node.Month,
        expiryYear: node.Year,
      }
    })
  }

  return list
}
export const convertAvailableCreditCardsGraphQLToReact = (originalData) => {
  let list = []

  if (typeof originalData.readCreditCards != 'undefined' && typeof originalData.readCreditCards.edges != 'undefined') {
    const edges = originalData.readCreditCards.edges

    list = edges.map((item, index) => {
      const node = item.node

      let label = []

      if (node.CardName) {
        label.push(node.CardName)
      }
      if (node.Title) {
        label.push(node.Title)
      }

      return {
        value: node.ID,
        label: label.join(' - '),
        expiryMonth: node.Month,
        expiryYear: node.Year,
      }
    })
  }

  return list
}

export const convertCreditCardDataToAccountList = (data, defaultListItemID) => {
  const finalData = data.map((item) => {
    return {
      id: item.value,
      info: item.label,
      subinfo: item.expiryMonth + '/' + item.expiryYear,
      isDefault: item.value == defaultListItemID,
    }
  })

  return finalData
}
export const convertAddressDataToAccountList = (data, defaultListItemID) => {
  const finalData = data.map((item) => {
    return {
      id: item.id,
      info: generateFullAddress(item),
      isDefault: item.id == defaultListItemID,
      enDefaultltAddress: item.enDefaultltAddress,
    }
  })

  return finalData
}
export const convertCartReportData = (report) => {
  if (!report) {
    return null
  }

  let list = {}
  Object.entries(report).map(([key, data]) => {
    list[key] = JSON.parse(data)
  })

  return list
}
export const isAllGoodCartReport = (processedData) => {
  let status = true

  if (processedData != null) {
    Object.entries(processedData).map(([key, data]) => {
      if (data.status == 0) {
        status = false
      }
    })
  }

  return status
}
export const generateSupplierCartKey = (buyableID, casePrice) => {
  return `ID:${buyableID}-CasePrice:${casePrice}`
}
export const getDiscountTypeLabel = (discountType) => {
  /**
   * No more 'Percentage Discount'
   */
  switch (discountType) {
    case 3:
    case 6:
      return 'Case Discount'
    case 5:
      return 'Case Price'
    default:
      return discountType
  }
}
export const getDiscountAmountLabel = (discountType, amount) => {
  switch (discountType) {
    case 3:
    case 5:
      return Numeral(amount).format('$0,0.00')
    case 6:
      return Numeral(amount / 100).format('0.000%')
    default:
      return amount
  }
}

export const convertZonesToReactSelect = (originalData) => {
  const data = originalData
    .filter((item) => {
      /**
       * Filter Groups if no member exists on them. Avoid Crashes on Discount Syncing
       */
      return item.node.Members.edges?.length > 0
    })
    .map((item) => {
      const { ID, Title, DefaultDiscountMemberID } = item.node
      let MemberID = -1

      if (item.node.Members && item?.node?.Members?.edges?.[0]?.node?.ID) {
        MemberID = item.node.Members.edges[0].node.ID
      }

      return {
        label: Title.trim(),
        value: ID,
        MemberID: DefaultDiscountMemberID != 0 || DefaultDiscountMemberID != null ? DefaultDiscountMemberID : MemberID,
      }
    })

  return data
}

export const convertWholesalerZonesToReactSelect = (originalData) => {
  const data = originalData
    .filter((item) => {
      /**
       * Filter Groups if no member exists on them. Avoid Crashes on Discount Syncing
       */
      return item.node.Members.edges?.length > 0
    })
    .map((item) => {
      const { ID, Title, DefaultDiscountMemberID } = item.node

      let MemberID = -1
      let Code = ''

      if (
        item.node.Members &&
        item?.node?.Members?.edges?.[0]?.node?.ID &&
        item.node.Members.edges[0].node?.Warehouse?.Code
      ) {
        MemberID = item.node.Members.edges[0].node.ID
        Code = item.node.Members.edges[0].node?.Warehouse?.Code
      }

      return {
        label: Title.trim(),
        value: ID,
        MemberID: DefaultDiscountMemberID != 0 || DefaultDiscountMemberID != null ? DefaultDiscountMemberID : MemberID,
        Location: Code || '',
      }
    })

  return data
}

export const convertSingleZoneToReactSelect = (zone = {}) => {
  if (Object.keys(zone)?.length == 0) {
    return {}
  }

  const { ID, Title, DefaultDiscountMemberID } = zone

  let MemberID = -1
  let Code = ''

  if (zone.Members && zone?.Members?.edges?.[0]?.node?.ID && zone?.Members?.edges?.[0]?.node?.Warehouse?.Code) {
    MemberID = zone?.Members?.edges?.[0]?.node?.ID
    Code = zone?.Members?.edges?.[0]?.node?.Warehouse?.Code
  }

  let data = {
    label: Title.trim(),
    value: ID,
    MemberID: DefaultDiscountMemberID != 0 || DefaultDiscountMemberID != null ? DefaultDiscountMemberID : MemberID,
    Location: Code || '',
  }

  return data
}

export const convertThreeEditPlCreditTerms = (creditTerms) => {
  if (creditTerms.length === 0) return []
  return creditTerms.map((creditTerm) => {
    return {
      label: creditTerm.Terms,
      value: creditTerm.TermID,
    }
  })
}

export const selectThreePlCreditTermLabel = (creditTerms, ID) => {
  let label = ''
  creditTerms.forEach((term) => {
    if (term.value == ID) {
      label = term.label
    }
  })
  return label
}

export const getReportStatusColor = (value, activeStatus) => {
  let color = ''
  if (activeStatus === 'credit') {
    InvoiceStatusColor.forEach((status) => {
      if (status.value === value) {
        color = status.class
      }
    })
  } else {
    PurchaseStatusColor.forEach((status) => {
      if (status.value === value) {
        color = status.class
      }
    })
  }
  return color
}

export const getReportStatusTitle = (value, activeStatus) => {
  let title = ''
  if (activeStatus === 'credit') {
    InvoiceStatusColor.forEach((status) => {
      if (status.value === value) {
        title = status.label
      }
    })
  } else {
    PurchaseStatusColor.forEach((status) => {
      if (status.value === value) {
        title = status.label
      }
    })
  }
  return title
}

export function validateCustomerForm(validationKeys, detail) {
  let flag = true
  validationKeys.forEach((key) => {
    if (flag === true && (detail[key.name] === undefined || detail?.[key.name] === '')) {
      flag = false
    }
    if (flag === true && key.type === 'email' && !validateEmailValue(detail?.[key.name])) {
      flag = false
    }
  })
  return flag
}

export function validateProductForm(validationKeys, detail) {
  let flag = true
  // console.log("validateProductForm ===== 11111" , {validationKeys, detail})
  validationKeys.forEach((key) => {
    // console.log("validateProductForm ===== 22222", detail[key.name] === undefined || detail?.[key.name] === '' ||  detail?.[key.name] == 0, detail?.[key.name], 'Validated')
    if (flag === true && (detail[key.name] === undefined || detail?.[key.name] == 0 || detail?.[key.name] === '')) {
      flag = false
    }
    if (flag === true && key.type === 'email' && !validateEmailValue(detail?.[key.name])) {
      flag = false
    }
  })
  return flag
}

export function validateEmailValue(value) {
  // if (!/[A-Za-z0-9_.\-]+@([A-Za-z0-9_\-]+\.)+[A-Za-z]{2,4}/.test(value)) {
  if (!/[A-Za-z0-9_.-]+@([A-Za-z0-9_-]+\.)+[A-Za-z]{2,4}/.test(value)) {
    return false
  }
  return true
}

export function numberFormat(number) {
  return parseFloat(number).toLocaleString(undefined, { minimumFractionDigits: 2 })
}

export function csvExportListConverter(list) {
  return list.map((item) => {
    if (item.isCredit === true) {
      return {
        'Order ID': item.transactionID,
        'Invoice Num': item.invoiceNum || '',
        'Receive Date': item.receiveDate ? moment(item.receiveDate).format('DD.MM.YYYY') : '',
        'Supplier Name': item.transactionReference,
        // Status: getReportStatusTitle(item.status, 'credit'),
        'Purchase Total': item.purchaseTotal || '0.00',
        Payment: item.payment || '0.00',
        'Open Balance': item.balance || '0.00',
        // POPDF: item.invoiceURL,
      }
    } else {
      return {
        InvoiceID: item.transactionID,
        Date: item.date ? moment(item.date).format('DD.MM.YYYY') : '',
        'Account Name': item.transactionReference,
        // Status: getReportStatusTitle(item.status, 'debit'),
        Total: item.debit || '0.00',
        Payment: item.credit || '0.00',
        'Open Balance': item.balance || '0.00',
        // POPDF: item.invoiceURL,
        Receipt: item.receipt,
      }
    }
  })
}

export const formatNumberWithCommas = (x) => {
  let parsed = parseFloat(x).toFixed(2)
  return parsed?.toString()?.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const convertLocationsListIntoSelect = (list = []) => {
  if (list.length == 0) {
    return list
  }
  let newList = []
  for (let i = 0; i < list.length; i++) {
    let obj = {
      id: list[i].PostalCode,
      label: `${list[i].LocationID || ''} - ${list[i].Address || list[i].Address2 || ''} - ${list[i].City || ''}`,
    }
    newList.push(obj)
  }
  return newList
}

export const convertOneAsnDetailToReact = (data) => {
  if (Object.keys(data).length === 0) {
    return data
  }
  let newObj = {}
  newObj.id = data.ID || 0
  newObj.dcLocation = data.DCLocation || ''
  newObj.referenceNumber = data.ReferenceNumber || ''
  newObj.contactEmail = data.ContactEmail || ''
  newObj.freightSolution = data.FreightSolution || ''
  newObj.pickUpLocation = data.PickUpLocation || ''
  newObj.reqDateOfPickUp = getFormattedDate(data.ReqDateOfPickUp)
  newObj.dcDeliveryDate = getFormattedDate(data.DCDeliveryDate)
  newObj.description = data.Description || ''
  newObj.addressLine1 = data.AddressLine1 || ''
  newObj.addressLine2 = data.AddressLine2 || ''
  newObj.suburb = data.Suburb || ''
  newObj.postCode = data.PostCode || ''
  newObj.locationPhone = data.LocationPhone || ''
  newObj.locationEmail = data.LocationEmail || ''
  newObj.loscamPallets = data.LoscamPallets || 0
  newObj.chepPallets = data.ChepPallets || 0
  newObj.plainPallets = data.PlainPallets || 0
  newObj.status = data.Status || ''
  return newObj
}

export const getFormattedDate = (date) => {
  if (!date) {
    return ''
  }
  let formattedDate = date?.split('-')?.reverse()?.join('-')
  return formattedDate
}

export function csvExportAtRiskStockConverter(list) {
  return list.map((item) => {
    return {
      // SupplierProductNum: item?.supplierProductNum,
      Location: item?.location,
      'Product ID': item?.productID,
      'Product Name': item?.productName,
      'Expiration Date':
        item?.expirationDate && !moment(item?.expirationDate).isSame('1970-01-01')
          ? moment(item.expirationDate).format('DD.MM.YYYY')
          : 'Vintage',
      Status: item?.status,
      // 'Product Type': item?.productType,
      'SOH (Cases)': item?.sOHSales,
      'Last 4 Weeks Sales (Cases)': item?.last4WeeksSalesCases,
      'Average Weekly Sales (Cases)': item?.averageWeeklySalesCases,
      // Vintage: item?.vintage,
    }
  })
}

export function csvExportSOHConverter(list) {
  return list.map((item) => {
    return {
      'Product ID': item?.productID,
      'Product Name': item?.productName,
      Location: item?.location,
      'Cases On Hand': item?.casesOnHand,
      'Pending Sales': item?.pendingSale,
      'Cases On Order': item?.caseOnOrder,
      'Months Stock': item?.monthsStock,
      'Sales Per Month': item?.casesSoldThisMonth,
      Status: item?.status,
      // 'Months Stock': item?.daysOfInventory,
    }
  })
}

export const mergePriceWithSingleProductDetail = (product = {}, prices = []) => {
  if ((product && Object.keys(product).length == 0) || prices.length == 0) {
    return product
  }

  let newProduct = { ...product }
  let found = prices.find((item) => item.BuyableID == product.productid)

  newProduct.PriceAdl = found?.PriceAdl || 0
  newProduct.PriceBris = found?.PriceBris || 0
  newProduct.PriceCns = found?.PriceCns || 0
  newProduct.PriceMel = found?.PriceMel || 0
  newProduct.PriceSyd = found?.PriceSyd || 0

  return newProduct
}

export function csvSalesReportConverter(list) {
  return list.map((item) => {
    return {
      Location: item?.Location,
      DeliveryDate: item?.DeliveryDate,
      'PO Num': item?.Brand,
      Vol: item?.Vol,
      'Product Name': item?.productName,
      'Cases/Units': item?.Cases,
      Company: item?.Company,
      City: item?.City || '',
      'Post Code': item?.PostCode || '',
      'Customer Type': item?.Group,
      'Invoice#': item?.Territory,
    }
  })
}

export const titleCaseTextConverter = (str = '') => {
  let orignalStr = str?.trim() || ''

  if (!orignalStr.length) {
    return orignalStr
  }

  return orignalStr
    ?.toLowerCase()
    .split(' ')
    .map(function (word) {
      return word?.replace(word[0], word[0]?.toUpperCase())
    })
    .join(' ')
}

export function csvTransBinReportConverter(list) {
  return list.map((item) => {
    return {
      Date: item?.Date ? moment(item.Date).format('DD.MM.YYYY') : '',
      'Product ID': item?.ProductID || '',
      'Product Name': item?.ProductName || '',
      'Transaction Type': item?.TransactionType || '',
      'Invoice/PO': item?.InvoicePO || '',
      Customer: item?.Customer || '',
      Quantity: item?.Quantity || '',
    }
  })
}

export function myOrdersToGroupsDataConverter(list = []) {
  if (list.length == 0) {
    return []
  }

  let grouped = {}

  for (let ele of list) {
    if (grouped[`${ele?.reference}`]) {
      grouped[`${ele?.reference}`]['totalOrdered'] = grouped[`${ele?.reference}`]['totalOrdered'] + (ele?.ordered || 0)
      grouped[`${ele?.reference}`]['totalReceived'] =
        grouped[`${ele?.reference}`]['totalReceived'] + (ele?.received || 0)
      grouped?.[`${ele?.reference}`]?.['subRows']?.push(ele)
    } else {
      grouped[`${ele?.reference}`] = ele
      grouped[`${ele?.reference}`]['totalOrdered'] = ele?.ordered || 0
      grouped[`${ele?.reference}`]['totalReceived'] = ele?.received || 0
      grouped[`${ele?.reference}`]['subRows'] = [ele]
    }
  }

  return Object.values(grouped)
}

export function csvRctiDollarChargeReportConverter(list) {
  return list.map((item) => {
    return {
      Location: item?.Location || '',
      'Delivery Date': item?.DeliveryDate ? moment(item.DeliveryDate).format('DD.MM.YYYY') : '',
      'Invoice ID': item?.InvoiceID || '',
      'Customer Name': item?.CustomerName || '',
      City: item?.City || '',
      'Postal Code': item?.PostalCode || '',
      'Product ID': item?.ProductID || '',
      'Product Name': item?.ProductName || '',
      'RCTI Description': item?.RCTIDescription || '',
      'Charge Type': item?.ChargeType || '',
      'Invoice Num': item?.InvoiceNum || '',
      'Num Units': item?.NumUnits ? parseFloat(item?.NumUnits).toFixed(2) : '0.00',
      Cases: item?.Cases ? parseFloat(item?.Cases).toFixed(2) : '$0.00',
      'Buy Price': item?.BuyPrice ? parseFloat(item?.BuyPrice).toFixed(2) : '$0.00',
      Fee: item?.PickFee ? parseFloat(item?.PickFee).toFixed(2) : '$0.00',
    }
  })
}

export function csvBillingDollarChargeReportConverter(list) {
  return list.map((item) => {
    return {
      'Delivery Date': item?.ChargeDate ? moment(item.ChargeDate).format('DD.MM.YYYY') : '',
      'Invoice ID': item?.InvoiceID || '',
      'PO Num': item?.PONum || '',
      'Customer Name': item?.CustomerName || '',
      City: item?.City || '',
      'Postal Code': item?.PostalCode || '',
      'Charge Zone': item?.ChargeZone || '',
      'Product ID': item?.ProductID || '',
      ProductName: item?.ProductName || '',
      Pallets: item?.Pallets ? parseFloat(item?.Pallets).toFixed(2) : '0.00',
      Layers: item?.Layers ? parseFloat(item?.Layers).toFixed(2) : '0.00',
      Cases: item?.Cases ? parseFloat(item?.Cases).toFixed(2) : '0.00',
      Kegs: item?.Kegs ? parseFloat(item?.Kegs).toFixed(2) : '0.00',
      Units: item?.Units ? parseFloat(item?.Units).toFixed(2) : '0.00',
      'Total Pick Charge': item?.TotalPickCharge ? parseFloat(item?.TotalPickCharge).toFixed(2) : '$0.00',
      'Total Freight Charge': item?.TotalFreightCharge ? parseFloat(item?.TotalFreightCharge).toFixed(2) : '$0.00',
    }
  })
}

export function csvRctiPercentageChargeReportConverter(list) {
  return list.map((item) => {
    return {
      Location: item?.Location || '',
      'Charge Date': item?.ChargeDate ? moment(item.ChargeDate).format('DD.MM.YYYY') : '',
      'Invoice ID': item?.InvoiceID || '',
      'Customer Name': item?.CustomerName || '',
      'Product ID': item?.ProductID || '',
      'Product Name': item?.ProductName || '',
      'RCTI Description': item?.RCTIDescription || '',
      'Invoice Num': item?.InvoiceNum || '',
      'Num Units': item?.NumUnits ? parseFloat(item?.NumUnits).toFixed(2) : '0.00',
      Cases: item?.Cases ? parseFloat(item?.Cases).toFixed(2) : '0.00',
      'Case Sell Price': item?.CaseSellPrice ? parseFloat(item?.CaseSellPrice).toFixed(2) : '$0.00',
      'Fee Per Case': item?.FeePerCase ? parseFloat(item?.FeePerCase).toFixed(2) : '$0.00',
      'Case Buy Price': item?.CaseBuyPrice ? parseFloat(item?.CaseBuyPrice).toFixed(2) : '$0.00',
      'Total Buy Price': item?.TotalBuyPrice ? parseFloat(item?.TotalBuyPrice).toFixed(2) : '$0.00',
    }
  })
}

export function csvBillingPercentageChargeReportConverter(list) {
  return list.map((item) => {
    return {
      'Delivery Date': item?.DeliveryDate ? moment(item.DeliveryDate).format('DD.MM.YYYY') : '',
      'Invoice ID': item?.InvoiceID || '',
      'PO Num': item?.PONum || '',
      Location: item?.Location || '',
      'Customer Name': item?.CustomerName || '',
      'Product ID': item?.ProductID || '',
      'Product Name': item?.ProductName || '',
      Units: item?.Units ? parseFloat(item?.Units).toFixed(2) : '0.00',
      Cases: item?.Cases ? parseFloat(item?.Cases).toFixed(2) : '0.00',
      'Case Sell Price': item?.CaseSellPrice ? '$' + parseFloat(item?.CaseSellPrice).toFixed(2) : '$0.00',
      'Charge Per Case': item?.ChargePerCase ? '$' + parseFloat(item?.ChargePerCase).toFixed(2) : '$0.00',
      'Total Charges': item?.TotalCharges ? '$' + parseFloat(item?.TotalCharges).toFixed(2) : '$0.00',
    }
  })
}

export function csvPurchasesReportConverter(list) {
  return list.map((item) => {
    return {
      'Time Created': item?.TimeCreated
        ? moment(item?.TimeCreated, 'YYYY-MM-DD hh:mm:ss').format('DD.MM.YYYY hh:mm:ss')
        : '',
      'Purchase ID': item?.PurchaseID ? item?.PurchaseID : '',
      Warehouse: item?.Warehouse ? item?.Warehouse : '',
      'Receive Date': item?.ReceiveDate ? moment(item?.ReceiveDate).format('DD.MM.YYYY') : '',
      'PO Num': item?.PONum ? item?.PONum : '',
      'Product ID': item?.ProductID ? item?.ProductID : '',
      'Product Name': item?.ProductName ? item?.ProductName : '',
      Status: item?.Status ? item?.Status : '',
      // 'Public PDF Link': item?.PublicPDFLink ? item?.PublicPDFLink : "",
      'Ordered Cases': item?.OrderedCases ? parseFloat(item?.OrderedCases).toFixed(2) : '0.00',
      'Received Cases': item?.ReceivedCases ? parseFloat(item?.ReceivedCases).toFixed(2) : '0.00',
    }
  })
}

export function csvOutOfStockReportConverter(list) {
  return list.map((item) => {
    return {
      'Delivery Date': item?.DeliveryDate ? moment(item?.DeliveryDate).format('DD.MM.YYYY') : '',
      'Order Type': item?.OrderType ? item?.OrderType : '',
      'Customer Name': item?.CustomerName ? item?.CustomerName : '',
      'Invoice #': item?.Invoice ? item?.Invoice : '',
      // 'POD': item?.POD ? item?.POD : "",
      'Web Order #': item?.WebOrder ? item?.WebOrder : '',
      Reason: item?.Reason ? item?.Reason : '',
      Warehouse: item?.Warehouse ? item?.Warehouse : '',
      'Product ID': item?.ProductID ? item?.ProductID : '',
      'Product Name': item?.ProductName ? item?.ProductName : '',
      'PO Num': item?.PONum ? item?.PONum : '',
      Ordered: item?.Ordered ? parseFloat(item?.Ordered).toFixed(2) : '0.00',
      Received: item?.Received ? parseFloat(item?.Received).toFixed(2) : '0.00',
      'Out Of Stock Qty': item?.OutOfStockQty ? parseFloat(item?.OutOfStockQty).toFixed(2) : '0.00',
    }
  })
}

//sorting method for react table columns
export function sortStringColumn(a, b) {
  if (a == null) {
    a = ''
  }

  if (b == null) {
    b = ''
  }
  if (a?.length === b?.length) {
    return a > b ? 1 : -1
  }
  return a?.length > b?.length ? 1 : -1
}

export function sortNumberColumn(a, b) {
  if (a == null) {
    a = ''
  }

  if (b == null) {
    b = ''
  }

  return Number(a) > Number(b) ? 1 : -1
}

export const getCurrencyPrefixNumber = (value = 0) => {
  return value < 0 ? '-$' + numberFormat(Math.abs(value)) : '$' + numberFormat(value)
}

export const getAvailableShipFromLocation = (locations = [], threePlLocations = {}) => {
  if (Object.keys(threePlLocations)?.length == 0) {
    return [
      {
        label: 'Location',
        value: '',
        locationCheck: '',
      },
    ]
  }
  let filteredLocations = locations?.filter((item) => threePlLocations[item?.locationCheck])
  let withDefaultData = [
    {
      label: 'Location',
      value: '',
      locationCheck: '',
    },
  ].concat(filteredLocations)
  return withDefaultData
}

export const getWeeklyStatusClass = (status) => {
  let found = WeekViewOrderStatusList?.find((ele) => ele.id == status)
  if (found) {
    return found?.class
  }

  return ''
}

export function csvTransactionDetailReportConverter(list) {
  return list.map((item) => {
    return {
      'Delivery Date': item?.DeliveryDate ? moment(item.DeliveryDate).format('DD.MM.YYYY') : '',
      'Product ID': item?.ProductID || '',
      'Order Type': item?.OrderType || '',
      'Product Name': item?.ProductName || '',
      'Customer Name': item?.CustomerCompany || '',
      'Invoice ID': item?.InvoiceID || '',
      'Web Order #': item?.TranslationInvoiceNum || '',
      Warehouse: item?.Location || '',
      'PO Num': item?.PONum || '',
      'PO/Invoice Num': item?.PoInvoiceNum || '',
      Ordered: item?.Ordered ? parseFloat(item?.Ordered).toFixed(2) : '0.00',
      Received: item?.NumUnits ? parseFloat(item?.NumUnits).toFixed(2) : '0.00',
    }
  })
}

export function csvBillingChargeInvoiceReportConverter(list) {
  return list.map((item) => {
    return {
      Location: item?.Location || '',
      'Charge Type': item?.ChargeType || '',
      'Billing Product Name': item?.BillingProductName || '',
      'Invoice ID': item?.InvoiceID || '',
      'Invoice Num': item?.InvoiceNum || '',
      Date: item?.Date ? moment(item.Date).format('DD.MM.YYYY') : '',
      Company: item?.Company || '',
      'Product Name': item?.ProductName || '',
      Address: item?.Address || '',
      City: item?.City || '',
      'Postal Code': item?.PostalCode || '',
      'Charge Zone': item?.ChargeZone || '',
      Quantity: item?.Quantity ? parseFloat(item?.Quantity).toFixed(2) : '0.00',
      'Num Units': item?.NumUnits ? parseFloat(item?.NumUnits).toFixed(2) : '0.00',
      Cases: item?.Cases ? parseFloat(item?.Cases).toFixed(2) : '0.00',
      Kegs: item?.Kegs ? parseFloat(item?.Kegs).toFixed(2) : '0.00',
      Layers: item?.Layers ? parseFloat(item?.Layers).toFixed(2) : '0.00',
      Pallets: item?.Pallets ? parseFloat(item?.Pallets).toFixed(2) : '0.00',
      'Year Week': item?.YearWeek ? parseFloat(item?.YearWeek).toFixed(2) : '0.00',
      Rate: item?.Rate ? parseFloat(item?.Rate).toFixed(2) : '0.00',
      Fee: item?.Fee ? parseFloat(item?.Fee).toFixed(2) : '0.00',
    }
  })
}

export function convertSaleQuoteDetailToReact(quoteList = [], itemsList = []) {
  let newList = [...quoteList]

  if (newList[0]?.node) {
    newList[0].node['SalesQuoteItems'] = { edges: itemsList }
  }

  return newList
}

const customerPromoAppliesToData = ['Customer', 'Customer Group']

export const customerPromoAppliesToOptions = customerPromoAppliesToData.map((item) => {
  return {
    label: item,
    value: item,
  }
})
